/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Reactivate_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not reactivate this member." |
*
* @param {Members_Reactivate_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_reactivate_error = /** @type {((inputs?: Members_Reactivate_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Reactivate_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Mitglied konnte nicht reaktiviert werden.")
	return /** @type {LocalizedString} */ ("Could not reactivate this member.")
});